<nav class="bottom-nav" aria-label="Primary">
  <button type="button" class="bn-item" [class.active]="isHomeActive()" (click)="goHome()" aria-label="Home">
    <mat-icon>home</mat-icon>
    <span class="bn-label">Home</span>
  </button>

  @for (menu of quickMenus; track menu.MenuID) {
  <button type="button" class="bn-item" [class.active]="isMenuActive(menu)" (click)="go(menu)"
    [attr.aria-label]="menu.MenuName">
    @if (menu.Svg_Default) {
    <span class="bn-icon" [innerHtml]="menu.Svg_Default | sanitizer : 'html'"></span>
    } @else {
    <mat-icon>apps</mat-icon>
    }
    <span class="bn-label">{{ menu.MenuName }}</span>
  </button>
  }

  <button type="button" class="bn-item" (click)="layout.toggleDrawer()" aria-label="More menu">
    <mat-icon>menu</mat-icon>
    <span class="bn-label">More</span>
  </button>
</nav>
